import { cn } from '../../helpers/classnames'

export interface JosefSegmentedControlOption {
  value: string
  label: string
  badge?: number
}

export interface JosefSegmentedControlProps {
  options: JosefSegmentedControlOption[]
  value: string
  onChange: (value: string) => void
  className?: string
  size?: 'sm' | 'md'
}

export function JosefSegmentedControl({
  options,
  value,
  onChange,
  className,
  size = 'md',
}: JosefSegmentedControlProps) {
  return (
    <div
      className={cn(
        'inline-flex bg-white dark:bg-black p-1 border border-black/10 dark:border-white/10 rounded-full gap-0.5',
        className
      )}
    >
      {options.map((option) => {
        const isActive = value === option.value
        return (
          <button
            key={option.value}
            type="button"
            onClick={() => onChange(option.value)}
            className={cn(
              'relative rounded-full font-medium transition-all duration-200',
              size === 'sm' ? 'px-3 py-1 text-xs' : 'px-4 py-1.5 text-sm',
              isActive
                ? 'bg-black dark:bg-white text-white dark:text-black'
                : 'text-neutral-600 dark:text-neutral-400 hover:text-black dark:hover:text-white hover:bg-black/5 dark:hover:bg-white/5'
            )}
          >
            {option.label}
            {option.badge !== undefined && option.badge > 0 && (
              <span
                className={cn(
                  'absolute -top-1 -right-1 min-w-[18px] h-[18px] flex items-center justify-center rounded-full text-[10px] font-bold',
                  isActive
                    ? 'bg-white dark:bg-black text-black dark:text-white'
                    : 'bg-black dark:bg-white text-white dark:text-black'
                )}
              >
                {option.badge > 99 ? '99+' : option.badge}
              </span>
            )}
          </button>
        )
      })}
    </div>
  )
}
